import { STATUS, USER_TYPE_GUEST } from '@app/constants/commonConstants';
import { AlloyButton, AlloyIcon, useModal } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { iconSize } from '../constants';
import ShareCartCILGModal from '../modal/ShareCartCILGModal/ShareCartCILGModal';
import ShareCartButtonForRegisteredUser from '../ShareCartButtonForRegisteredUser';

const ShareCartButton = () => {
  const shareCartCILGModalProps = useModal();
  const [t] = useTranslation();
  const handleClick = () => {
    shareCartCILGModalProps.open();
  };
  const shareCartTitle = t('SHARE_CART');
  const downloadLabel = t('SHARE');

  const shoppingPreferenceDataStatus = useSelector(
    s => s.shoppingPreferences.shoppingPreferenceDataStatus
  );
  const isOrderPriceAvailabilityLoading = useSelector(
    s => s.orders?.isOrderPriceAvailabilityLoading
  );
  const getCurrentOrderStatus = useSelector(
    s => s.orders?.getCurrentOrderStatus
  );
  const userType = useSelector(state => state.common.userType);
  const isRegisteredUser = userType && userType !== USER_TYPE_GUEST;
  const isLoggedIn = !!isRegisteredUser;
  const isBuyOnBehalf = useSelector(s => s.common?.isBuyOnBehalf) || false;

  const showShareCartButtonWhenBuyOnBehalfForRegisteredUsers =
    isLoggedIn && isBuyOnBehalf;

  const shoppingPreferencesLoaded =
    shoppingPreferenceDataStatus === STATUS.REJECTED ||
    shoppingPreferenceDataStatus === STATUS.RESOLVED;
  const isOrdersLoading =
    getCurrentOrderStatus === STATUS.IDLE ||
    getCurrentOrderStatus === STATUS.PENDING;
  const hasOrdersAndShoppingPreferencesResolved = isLoggedIn
    ? !isOrdersLoading &&
      shoppingPreferencesLoaded &&
      !isOrderPriceAvailabilityLoading
    : !isOrdersLoading && !isOrderPriceAvailabilityLoading;

  return showShareCartButtonWhenBuyOnBehalfForRegisteredUsers ? (
    <ShareCartButtonForRegisteredUser />
  ) : (
    <>
      <AlloyButton
        aria-label={shareCartTitle}
        className="d-inline-flex align-items-center mt-2 mt-md-0 mb-4 mb-md-0 p-0 mx-5"
        buttonType="ghost"
        onClick={handleClick}
        disabled={!hasOrdersAndShoppingPreferencesResolved}
      >
        <AlloyIcon
          title={downloadLabel}
          icon="icon-share"
          height={iconSize}
          width={iconSize}
          className="d-none d-md-inline-block me-2"
        />
        <div className="u-fs--16 ps-md-1 ps-lg-0">{shareCartTitle}</div>
      </AlloyButton>
      <ShareCartCILGModal {...shareCartCILGModalProps} />
    </>
  );
};

export default ShareCartButton;
